var _defs, _g, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspekcjaZielona(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #647f94;\n      }\n\n      .st0, .st1 {\n        stroke: #d9d9d9;\n        stroke-miterlimit: 1.6;\n        stroke-width: .4px;\n      }\n\n      .st1 {\n        fill: #d1cb0f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.2,0H18.8C8.4,0,0,8.4,0,18.8v162.5c0,10.4,8.4,18.8,18.8,18.8h162.5c10.4,0,18.8-8.4,18.8-18.8V18.8C200,8.4,191.6,0,181.2,0ZM173.7,13.7c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4-7.4-3.3-7.4-7.4,3.3-7.4,7.4-7.4ZM146.2,13.7c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4-7.4-3.3-7.4-7.4,3.3-7.4,7.4-7.4ZM118.6,13.7c4.1,0,7.4,3.3,7.4,7.4s-3.3,7.4-7.4,7.4-7.4-3.3-7.4-7.4,3.3-7.4,7.4-7.4ZM184.4,181.3c0,1.7-1.4,3.1-3.1,3.1H18.8c-1.7,0-3.1-1.4-3.1-3.1V40.6h168.8v140.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,104.4c1.1,0,2-.9,2-2,0-5.8,4.7-10.6,10.6-10.6s2-.9,2-2-.9-2-2-2c-8.1,0-14.6,6.6-14.6,14.6s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,142.6c7.3,0,14.1-2.1,19.9-5.8,4.6-2.9,8.5-6.8,11.4-11.4,3.7-5.7,5.8-12.6,5.8-19.9,0-20.5-16.6-37.1-37.1-37.1s-14.1,2.1-19.9,5.8c-4.6,2.9-8.5,6.8-11.4,11.4-3.7,5.7-5.8,12.6-5.8,19.9,0,20.4,16.6,37.1,37.1,37.1ZM71.5,93.5c2.5-4.9,6.5-8.9,11.4-11.4,3.6-1.9,7.7-2.9,12-2.9,14.5,0,26.3,11.8,26.3,26.3s-1.1,8.4-2.9,12c-2.5,4.9-6.5,8.9-11.4,11.4-3.6,1.9-7.7,2.9-12,2.9-14.5,0-26.3-11.8-26.3-26.3,0-4.3,1.1-8.4,2.9-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.4,141.5l16.4,16.4c1.6,1.6,3.6,2.4,5.7,2.4s4.1-.8,5.7-2.4c3.1-3.1,3.1-8.3,0-11.4l-16.4-16.4c-3,4.5-6.9,8.4-11.4,11.4Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 118.6,
    cy: 21.1,
    r: 7.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.2,
    cy: 21.1,
    r: 7.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 173.7,
    cy: 21.1,
    r: 7.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspekcjaZielona);
export default __webpack_public_path__ + "static/media/inspekcja_zielona.e9cb535ded68af7e92a079a35807799d.svg";
export { ForwardRef as ReactComponent };